import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
} from "@angular/common/http";
import { Observable } from "rxjs";

import { JwtService } from "../utilities/jwt.service";

@Injectable()
export class HttpTokenInterceptor implements HttpInterceptor {
  constructor(private jwtService: JwtService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const headersConfig = {
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    const token = this.jwtService.getToken();

    if (token) {
      headersConfig["Authorization"] = `Token ${token}`;
    }

    var request_ = req.clone({ setHeaders: headersConfig });
    var request = request_.clone({ withCredentials: true });
    return next.handle(request);
  }
}
